import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { all_routes } from '../../core/data/routes/all_routes';
import { AdminDashboardThree } from '../../core/data/json/admin-dashboard3';
import Header from '../common/components/header';
import Sidebar from '../common/components/sidebar';
import '../../style/admin/css/admin.css';

import Loading from '../../feature-module/components/loading';
import DashboardCharts from '../common/components/DashboardCharts';
import { useNavigate } from 'react-router-dom';

// Add interface for table data
interface TableData {
  id: number;
  service: string;
  amount: number;
  img: string;
  providerName: string;
  phone: string;
  provider: string;
  user: string;
  serviceImg: string;
  userImg: string;
  providerImg: string;
}

const Dashboard = () => {



  return (
    <><Header />
      <Sidebar /></>
  )
  
  // return (
  //   <>
  //     <Header />
  //     <Sidebar />

  //     <div className="page-wrapper" style={{ marginLeft: '270px' }}>
  //       <div className="content">
  //         <div className="row">
  //           <div className="col-lg-4  col-12 d-flex widget-path widget-service">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user">
  //                   <div className="home-userhead">
  //                     <div className="home-usercount">
  //                       <span>
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/user.svg"
  //                           alt="img"
  //                         />
  //                       </span>
  //                       <h6>Yolcu Sayısı</h6>
  //                       {loading && (
  //                         <Loading
  //                           style={{
  //                             position: 'absolute',
  //                             width: '100%',
  //                             height: '100%',
  //                             top: 0,
  //                             left: 0,
  //                             zIndex: 1,
  //                             background: 'rgba(255, 255, 255, 0.5)',
  //                           }}
  //                         />
  //                       )}
  //                     </div>
  //                   </div>
  //                   <div className="home-usercontent">
  //                     <div className="home-usercontents">
  //                       <div className="home-usercontentcount">
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/arrow-up.svg"
  //                           alt="img"
  //                           className="me-2"
  //                         />
  //                         <span className="counters" data-count={30}>
  //                           {
  //                             dashboardData?.uniqueCustomerCount?.data
  //                               ?.total_unique_customer_count_today
  //                           }
  //                         </span>
  //                       </div>
  //                       <h5>Bugün</h5>
  //                     </div>
  //                     <div className="home-usercontents">
  //                       <div className="home-usercontentcount">
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/arrow-up.svg"
  //                           alt="img"
  //                           className="me-2"
  //                         />

  //                         <span className="counters" data-count={30}>
  //                           {
  //                             dashboardData?.uniqueCustomerCount?.data
  //                               ?.total_unique_customer_count_yesterday
  //                           }
  //                         </span>
  //                       </div>
  //                       <h5>Dün</h5>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-4  col-12 d-flex widget-path widget-service">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user home-provider">
  //                   <div className="home-userhead">
  //                     <div className="home-usercount">
  //                       <span>
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/user-circle.svg"
  //                           alt="img"
  //                         />
  //                       </span>
  //                       <h6>Aktif Sürücü</h6>
  //                       {loading && (
  //                         <Loading
  //                           style={{
  //                             position: 'absolute',
  //                             width: '100%',
  //                             height: '100%',
  //                             top: 0,
  //                             left: 0,
  //                             zIndex: 1,
  //                             background: 'rgba(255, 255, 255, 0.5)',
  //                           }}
  //                         />
  //                       )}
  //                     </div>
  //                   </div>
  //                   <div className="home-usercontent">
  //                     <div className="home-usercontents">
  //                       <div className="home-usercontentcount">
  //                         <span className="counters" data-count={25}>
  //                           {dashboardData?.activeDriverCount?.data}
  //                         </span>
  //                       </div>
  //                       <h5>Bugün</h5>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <div className="col-lg-4  col-12 d-flex widget-path widget-service">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user home-subscription">
  //                   <div className="home-userhead">
  //                     <div className="home-usercount">
  //                       <span>
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/money.svg"
  //                           alt="img"
  //                         />
  //                       </span>
  //                       <h6>Toplam Rezervasyon</h6>
  //                       {loading && (
  //                         <Loading
  //                           style={{
  //                             position: 'absolute',
  //                             width: '100%',
  //                             height: '100%',
  //                             top: 0,
  //                             left: 0,
  //                             zIndex: 1,
  //                             background: 'rgba(255, 255, 255, 0.5)',
  //                           }}
  //                         />
  //                       )}
  //                     </div>
  //                   </div>
  //                   <div className="home-usercontent">
  //                     <div className="home-usercontents">
  //                       <div className="home-usercontentcount">
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/arrow-up.svg"
  //                           alt="img"
  //                           className="me-2"
  //                         />

  //                         <span className="counters" data-count={650}>
  //                           {
  //                             dashboardData?.salesThisMonth?.data
  //                               ?.total_sales_this_month.toFixed(2)
  //                           }{' '}
  //                           ₺
  //                         </span>
  //                       </div>
  //                       <h5>Bu Ay</h5>
  //                     </div>

  //                     <div className="home-usercontents">
  //                       <div className="home-usercontentcount">
  //                         <ImageWithBasePath
  //                           src="assets/admin/img/icons/arrow-up.svg"
  //                           alt="img"
  //                           className="me-2"
  //                         />
  //                         <span className="counters" data-count={650}>
  //                           {
  //                             dashboardData?.salesThisMonth?.data
  //                               ?.total_sales_last_month
  //                           }{' '}
  //                           ₺
  //                         </span>
  //                       </div>
  //                       <h5>Önceki Ay</h5>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>

  //         <DashboardCharts dashboardData={dashboardData} loading={loading} />
  //         <div className="row">
  //           <div className="col-lg-12 col-sm-12 widget-path">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user">
  //                   <div className="home-head-user home-graph-header">
  //                     <h2>Top Admin</h2>
  //                     {loading && (
  //                       <Loading
  //                         style={{
  //                           position: 'absolute',
  //                           width: '100%',
  //                           height: '100%',
  //                           top: 0,
  //                           left: 0,
  //                           zIndex: 1,
  //                           background: 'rgba(255, 255, 255, 0.5)',
  //                         }}
  //                       />
  //                     )}
  //                   </div>
  //                   <div className="table-responsive datatable-nofooter">
  //                     <table className="table datatable">
  //                       <DataTable
  //                         paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink"
  //                         currentPageReportTemplate="{first} to {last} of {total_rides}"
  //                         value={dashboardData?.topAdminsByRideCreation?.data?.slice(
  //                           0,
  //                           5,
  //                         )}
  //                       >
  //                         <Column field="username" header="İsim"></Column>
  //                         <Column
  //                           field="total_rides"
  //                           header="Toplam Yolculuk"
  //                         ></Column>
  //                         <Column
  //                           field="completed_rides"
  //                           header="Tamamlanan"
  //                         ></Column>
  //                         <Column
  //                           field="cancelled_rides"
  //                           header="İptal Edilen"
  //                         ></Column>
  //                       </DataTable>
  //                     </table>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="row">
  //           <div className="col-lg-6 col-sm-12 widget-path">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user">
  //                   <div className="home-head-user home-graph-header">
  //                     <h2>Top Müşteriler</h2>
  //                     {loading && (
  //                       <Loading
  //                         style={{
  //                           position: 'absolute',
  //                           width: '100%',
  //                           height: '100%',
  //                           top: 0,
  //                           left: 0,
  //                           zIndex: 1,
  //                           background: 'rgba(255, 255, 255, 0.5)',
  //                         }}
  //                       />
  //                     )}
  //                   </div>
  //                   <div className="table-responsive datatable-nofooter">
  //                     <table className="table datatable">
  //                       <DataTable
  //                         value={dashboardData?.topCustomers?.data?.slice(0, 5)}
  //                       >
  //                         <Column
  //                           field="phone_number"
  //                           header="Telefon"
  //                         ></Column>
  //                         <Column
  //                           field="total_rides"
  //                           header="Yolculuklar"
  //                         ></Column>
  //                       </DataTable>
  //                     </table>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6 col-sm-12 widget-path">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user">
  //                   <div className="home-head-user home-graph-header">
  //                     <h2>Top Sürücüler</h2>
  //                     {loading && (
  //                       <Loading
  //                         style={{
  //                           position: 'absolute',
  //                           width: '100%',
  //                           height: '100%',
  //                           top: 0,
  //                           left: 0,
  //                           zIndex: 1,
  //                           background: 'rgba(255, 255, 255, 0.5)',
  //                         }}
  //                       />
  //                     )}
  //                   </div>
  //                   <div className="table-responsive datatable-nofooter">
  //                     <table className="table datatable ">
  //                       <DataTable
  //                         paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink  "
  //                         currentPageReportTemplate="{first} to {last} of {totalRecords}"
  //                         value={dashboardData?.topDrivers?.data
  //                           ?.slice(0, 5)
  //                           .map((item: any) => ({
  //                             ...item.driver,
  //                             total_sales: item.total_sales,
  //                           }))}
  //                       >
                          
  //                         <Column field="first_name" header="İsim"></Column>
  //                         <Column
  //                           field="total_sales"
  //                           header="Toplam Kazanç"
  //                           body={(rowData: any) => (
  //                             <span>{rowData.total_sales.toFixed(2)}</span>
  //                           )}
  //                         ></Column>
  //                       </DataTable>
  //                     </table>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           {/* <div className="col-lg-4 col-sm-12 widget-path">
  //             <div className="card">
  //               <div className="card-body">
  //                 <div className="home-user">
  //                   <div className="home-head-user home-graph-header">
  //                     <h2>Top Admin Sürüş</h2>
  //                     {loading && (
  //                       <Loading
  //                         style={{
  //                           position: 'absolute',
  //                           width: '100%',
  //                           height: '100%',
  //                           top: 0,
  //                           left: 0,
  //                           zIndex: 1,
  //                           background: 'rgba(255, 255, 255, 0.5)',
  //                         }}
  //                       />
  //                     )}
  //                   </div>
  //                   <div className="table-responsive datatable-nofooter">
  //                     <table className="table datatable ">
  //                       <DataTable
  //                         paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink  "
  //                         currentPageReportTemplate="{first} to {last} of {ride_count}"
  //                         value={dashboardData?.mostEndedRidesPerAdmin?.data
  //                           ?.slice(0, 5)
  //                           .map((item: any) => ({
  //                             ride_count: item.ride_count,
  //                             username: item.username,
  //                           }))}
  //                       >
  //                         <Column field="username" header="İsim"></Column>
  //                         <Column
  //                           field="ride_count"
  //                           header="Tamamlanmış Yolculuklar"
  //                         ></Column>
  //                       </DataTable>
  //                     </table>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div> */}
  //         </div>
  //       </div>
  //     </div>
  //   </>
  // );
};

export default Dashboard;
